export default {"src":"/_next/static/media/tailored-Repayment.21f21a19.svg","height":120,"width":121};